import { RouteObject } from "react-router"
import { LogInView } from "./logIn.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { Widgets } from "@mui/icons-material"

export enum PathRotaLogIn {
    login = "/logIn"
}

const routerLogin: RouteObject = {
    path: PathRotaLogIn.login,
    element: <LogInView/>,
}


export const navigationToItemView = ()=> rotas.navigate(PathRotaLogIn.login)

export function startRouterLogIn(){

    return routerLogin
}